import { render } from "./IconArrownUp.vue?vue&type=template&id=674309e1&ts=true"
import script from "./IconArrownUp.vue?vue&type=script&lang=ts"
export * from "./IconArrownUp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__